const not32 = (a) => ~a;
export default not32;
